export function getEnvVariable(key) {
  if (window.electron) {
    return window.electron.env[key];
  } else {
    return process.env[key];
  }
}
